import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { CamelcaseToSpacePipe } from '../../pipes/camelcase-to-space.pipe';

@Component({
  selector: 'app-custom-dtable',
  templateUrl: './custom-dtable.component.html',
  styleUrls: ['./custom-dtable.component.scss'],
})
export class CustomDtableComponent implements OnInit {
  @Input() dataLoader: (page: number, size: number) => Promise<any>;
  @Input() columns: CColumn[] = [];
  @Input() detailFields: CDetailField[] = [];
  @Input() external = true;
  @ViewChild(DatatableComponent, { static: false }) mydatatable: DatatableComponent;
  page = {
    pageNumber: 0,
    size: 10,
    totalElements: 10
  };
  data: any[] = [];
  constructor(
    private helper: CommonMessageService,
    private camelCaseToSpace: CamelcaseToSpacePipe,
  ) { }

  ngOnInit() { }

  async reload() {
    if (this.external) {
      this.page.pageNumber = 0;
      this.page.size = 10;
      this.setPage({
        offset: 0,
      });
    } else {
      await this.loadData(this.page.size, this.page.pageNumber);
    }

  }

  async setPage(pageInfo) {
    if (!this.external) {
      return;
    }
    this.page.pageNumber = pageInfo.offset;
    console.log('pageInfo', pageInfo, this.page);
    await this.loadData(this.page.size, this.page.pageNumber);
  }

  private async loadData(size: number, page: number) {
    const loading = await this.helper.pleaseWaitLoading();
    try {
      const res = await this.dataLoader(page, size);
      console.log('Res:::', res, this.dataLoader);
      if (!res) {
        return;
      }
      this.data = res.content;
      if (this.data[0]) {
        const first = this.data[0];
        const keys = Object.keys(first);
        if (this.columns.length === 0) {
          // dynamic columns
          this.columns = keys.slice(0, 3).map(e => {
            return {
              name: this.camelCaseToSpace.transform(e, true),
              prop: e,
              frozenLeft: false,
              type: ((typeof e).toLowerCase()) as any
            };
          });
          this.detailFields = keys.slice(3).map(e => {
            return {
              prop: e,
              title: this.camelCaseToSpace.transform(e, true),
              type: ((typeof e).toLowerCase()) as any
            };
          });
          console.log('Columns:::', this.columns, this.detailFields);
        }
      }
      this.page.totalElements = res.totalElements;
    } catch (error) {
      this.helper.errorToast('Erreur' + error);
    } finally {
      loading.dismiss();
    }
  }

  toggleExpandRow(row) {
    console.log('Toggled Expand Row!', row);
    this.mydatatable.rowDetail.toggleExpandRow(row);
  }

  showDetail(ev) {
    console.log('Detail Toggled', ev);
  }
}

export interface CColumn {
  name: string;
  prop: string;
  frozenLeft?: boolean;
  type?: 'currency' | 'string' | 'date' | 'number';
}

export interface CDetailField {
  title: string;
  prop: string;
  type?: 'currency' | 'string' | 'date' | 'number';
}
